import { render, staticRenderFns } from "./AvailableOtherLabours.vue?vue&type=template&id=7d95fb2b&scoped=true"
import script from "./AvailableOtherLabours.vue?vue&type=script&lang=js"
export * from "./AvailableOtherLabours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d95fb2b",
  null
  
)

export default component.exports